import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import nexapi from '../../services/api';
import { BranchModel } from '../../types/models/BranchModel';


interface BranchResponse{
  data: BranchModel[];
  totalCount: number;
}

interface BranchState {
  data: BranchModel[];
  totalRecords: number;
  currentPage: number;
  loading: boolean;
  error: string | null;
  status: string | null;
}

const initialState: BranchState = {
  data: [],
  totalRecords: 0,
  currentPage: 1,
  loading: false,
  error: null,
  status: null
};

const API_URL = '/PettyCash';

export const fetchBranch = createAsyncThunk<BranchResponse, {
   filters: Record<string, any>; 
   page: number; 
   numberOfRecord: number; 
   userId: string;
   sortColumn?: string;
   sortOrder?: 'asc' | 'desc'; 
   companyId:string;
     iscompanySubype : boolean;
  }>(
  'pettyCashBranch/fetchBranch',
  async ({filters, page, numberOfRecord, userId, sortColumn = '', sortOrder = 'asc', companyId,iscompanySubype}) => {
    try {
        
      // Construct the query string with filters
      const searchUnit =  filters.search || "";
      const url = `${API_URL}/GetBranch?pagination=true&page=${page}&numberOfRecord=${numberOfRecord}&userId=${userId}&search=${searchUnit}&sortColumn=${sortColumn}&sortOrder=${sortOrder}&companyId=${companyId}&state=${filters.state}&userTimeZone=${filters.userTimeZone}&isCompanyBranch=${iscompanySubype}`;

      const response = await nexapi.post(url);
      const data = response.data;
      if (Array.isArray(data?.data)) {
        console.error('Branch Response:', data?.data);
        console.error('Branch Response Total Count:', data.totalCount);
        return {
          data: data.data,
          totalCount: data.totalCount, 
        };
      } else {
        console.error('Invalid API Response:', data);
        return { data: [], totalCount: 0 }; // Return a fallback structure
      }
    } catch (error) {
      console.error('API Call Failed:', error);
      throw error;
    }
  }
);

export const deleteApplication = createAsyncThunk<BranchResponse, { Id : string, UserId:string,reason: string}>(
  'pettyCashDivision/deleteApplication',
  async ({ Id,UserId,reason}) => {
    
    try {
      const [cleanId] = Id.includes('_') ? Id.split('_') : [Id];

      const payload = {
        Id: cleanId,
        UserId: UserId,
        reason: reason
      };
      const url = API_URL+"/ActivateBranch";
      const method = "post";
      const response = await nexapi[method](url, payload);

      
      response.data.statusCode = "200";
      return response.data.statusCode;
    } catch (error) {
      console.error('API Call Failed:', error);
      throw error;
    }
  }
);


const requestsSlice = createSlice({
  name: 'pettyCashBranch',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchBranch.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchBranch.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data;
        state.status = 'succeeded';
      })
      .addCase(fetchBranch.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Failed to fetch Branch';
      })
      .addMatcher(
        (action) => action.type.endsWith('/pending'),
        (state) => {
          state.status = 'loading';
        }
      )
      .addMatcher(
        (action) => action.type.endsWith('/rejected'),
        (state, action) => {
          state.status = 'failed';          
        }
      );
  },
});

export default requestsSlice.reducer;